import { Injectable } from '@angular/core';


@Injectable({
  providedIn: 'root'
})
export class TranslationService {

  private transaltions: Object = {
    hu: {
        alkalmi: 'Alkalmi',
        kötött_kelmék: 'Kötött kelmék',
        blúzanyagok: 'Blúzanyagok',
        műbőr: 'Műbőr',
        kabátanyagok: 'Kabátanyagok',
        szövetek: 'Szövetek',
        vásznak: 'Vásznak',
        szaténok: 'Szaténok',
        női_ruhaanyagok: 'Női ruhaanyagok',
        jacquardok: 'Jacquardok',
        jerseyk: 'Jerseyk',
        csipkék: 'Csipkék',
        hímzett_anyagok: 'Hímzett anyagok',
        bársonyok: 'Bársonyok',
        denimek: 'Denimek',
        tüllök: 'Tüllök',
        polárok: 'Polárok',
        bélések: 'Bélések',
        dekorációs_anyagok: 'Dekorációs anyagok',
        puplinok: 'Puplinok',
        inganyagok: 'Inganyagok',
        taftok: 'Taftok',
        abroszanyagok: 'Abroszanyagok',
        függönyök: 'Függönyök',
        díszlet_és_jelmez: 'Díszlet és jelmez',
        szezonális_termékek: 'Szezonális termékek',
        akciós_termékeink: 'Akciós termékeink',
        megosztás: 'Megosztás',
        pdf_cimke_letöltése: 'PDF cimke letöltése',
        vissza: 'Vissza',
        színek: 'Színek',
        szélesség: 'Szélesség',
        súly: 'Súly',
        anyagösszetétel: 'Anyagösszetétel',
        hasonló_termékeink: 'Hasonló Termékeink',
        további_termékeink: 'További termékeink',
        tavasz_nyár: 'Tavasz-Nyár',
        ősz_tél: 'Ősz-Tél',
        műszőrmék: 'Műszörmék'


      },
      en: {
        alkalmi: 'Fancy',
        kötött_kelmék: 'Knitted fabrics',
        blúzanyagok: 'Blouse women',
        műbőr: 'Fake leather',
        kabátanyagok: 'Coat fabric',
        szövetek: 'Suiting fabrics',
        vásznak: 'Linen',
        szaténok: 'Satin',
        női_ruhaanyagok: 'Women dress fabrics',
        jacquardok: 'Jacquards',
        jerseyk: 'Jersey',
        csipkék: 'Lace',
        hímzett_anyagok: 'Embroidery',
        bársonyok: 'Velvet',
        denimek: 'Denim',
        tüllök: 'Tulle',
        polárok: 'Flannel fleece',
        bélések: 'Lining',
        dekorációs_anyagok: 'Decor textiles',
        puplinok: 'Poplin',
        inganyagok: 'Shirts men',
        taftok: 'Taffeta',
        abroszanyagok: 'Tablecloth',
        függönyök: 'Curtain',
        díszlet_és_jelmez: 'Theatrical decor, costumes',
        szezonális_termékek: 'Seasonals fabrics',
        akciós_termékeink: 'Sales',
        megosztás: 'Share',
        pdf_cimke_letöltése: 'PDF label',
        vissza: 'Back',
        színek: 'Colors',
        szélesség: 'Width',
        súly: 'Weight',
        anyagösszetétel: 'Composition',
        hasonló_termékeink: 'Similar products',
        további_termékeink: 'Load more',
        tavasz_nyár: 'Spring- Summer',
        ősz_tél: 'Autumn-Winter',
        műszőrmék: 'Fake Furs'
      },
      ro: {
        alkalmi: 'Gală, fancy',
        kötött_kelmék: 'Materiale tricotate',
        blúzanyagok: 'Materiale pentru bluze',
        műbőr: 'Imitaţii de piele',
        kabátanyagok: 'Materiale de paltoane',
        szövetek: 'Stofe',
        vásznak: 'Docuri, tercoturi',
        szaténok: 'Satinuri',
        női_ruhaanyagok: 'Materiale pentru dame',
        jacquardok: 'Brocarduri',
        jerseyk: 'Lycra',
        csipkék: 'Dantele',
        hímzett_anyagok: 'Ţesături brodate',
        bársonyok: 'Catifea',
        denimek: 'Denimuri',
        tüllök: 'Tulle',
        polárok: 'Polar',
        bélések: 'Căptuşeli',
        dekorációs_anyagok: 'Ţesături pentru decoraţiuni',
        puplinok: 'Puplinuri',
        inganyagok: 'Materiale pentru cămăşi',
        taftok: 'Tafta',
        abroszanyagok: 'Ţesături pentru feţe de masă',
        függönyök: 'Perdele',
        díszlet_és_jelmez: 'Decoraţiuni şi costumaţii',
        szezonális_termékek: 'Produse de sezon',
        akciós_termékeink: 'Produse promoţionale',
        megosztás: 'Distribuire',
        pdf_cimke_letöltése: 'Descărcaţi eticheta PDF',
        vissza: 'Înapoi',
        színek: 'Culori',
        szélesség: 'Lăţime',
        súly: 'Greutate',
        anyagösszetétel: 'Compoziţie',
        hasonló_termékeink: 'Produse asemănătoare',
        további_termékeink: 'Alte produse',
        tavasz_nyár: 'Primăvară-Vară',
        ősz_tél: 'Toamnă-Iarnă',
        műszőrmék: 'Imitaṭie Blanặ'
    },
      sk: {
        alkalmi: 'Prílezitostné látky',
        kötött_kelmék: 'Pleteny materiál',
        blúzanyagok: 'Blúzoviny',
        műbőr: 'Umelá koža-koženka',
        kabátanyagok: 'Materiál na kabáty',
        szövetek: 'Tkaniny',
        vásznak: 'Plátno',
        szaténok: 'Satény',
        női_ruhaanyagok: 'Textilny materiál pre zeny',
        jacquardok: 'Jacquardy',
        jerseyk: 'Jersey',
        csipkék: 'čipky',
        hímzett_anyagok: 'Textil s vysivkou',
        bársonyok: 'Zamaty',
        denimek: 'Denim-riflovina',
        tüllök: 'Tyl',
        polárok: 'Polárny materiál',
        bélések: 'Podšívkový materiál',
        dekorációs_anyagok: 'Dekoračný materiál',
        puplinok: 'Pupliny',
        inganyagok: 'Plátno na kosele-halenkovina',
        taftok: 'Tafty',
        abroszanyagok: 'Materiál na obrusy',
        függönyök: 'Záclony',
        díszlet_és_jelmez: 'Efektné saty a kostymy',
        szezonális_termékek: 'Sezonálne látky',
        akciós_termékeink: 'Naše akciové výrobky',
        megosztás: 'Zdielanie',
        pdf_cimke_letöltése: 'Stiahnite si PDF znacku',
        vissza: 'SPAŤ',
        színek: 'Farby',
        szélesség: 'Sírka',
        súly: 'Hmotnost',
        anyagösszetétel: 'Zlozenie',
        hasonló_termékeink: 'Podobné vyrobky',
        további_termékeink: 'Ďalsie naše vŷrobky',
        tavasz_nyár: 'Leto-Jar',
        ősz_tél: 'Jeseň-Zima',
        műszőrmék: 'Umelá Kožušina'
      },
      sr: {
        alkalmi: 'Elegantni tekstili',
        kötött_kelmék: 'Pletenine',
        blúzanyagok: 'Materijali za bluze',
        műbőr: 'Umetna koža',
        kabátanyagok: 'Materijali za kapute',
        szövetek: 'Štof',
        vásznak: 'Platno',
        szaténok: 'Sateni',
        női_ruhaanyagok: 'Tekstili za žensku konfekciju',
        jacquardok: 'Jacquardi/Brokati',
        jerseyk: 'Jersey/Licra',
        csipkék: 'Čipke',
        hímzett_anyagok: 'Materijali sa vezom',
        bársonyok: 'Velvet',
        denimek: 'Jeans materijali',
        tüllök: 'Til',
        polárok: 'Polar',
        bélések: 'Postava',
        dekorációs_anyagok: 'Materijali za dekoraciju',
        puplinok: 'Puplini',
        inganyagok: 'Košuljari',
        taftok: 'Taft',
        abroszanyagok: 'Stoljnjaci',
        függönyök: 'Zavese',
        díszlet_és_jelmez: 'Scenski materijali i kostimi',
        szezonális_termékek: 'Sezonalni tekstili',
        akciós_termékeink: 'Akcijski materijali',
        megosztás: 'Podeli',
        pdf_cimke_letöltése: 'Preuzmi etiketu u PDF-u',
        vissza: 'Nazad',
        színek: 'Boje',
        szélesség: 'Širina',
        súly: 'Težina',
        anyagösszetétel: 'Sastav materijala',
        hasonló_termékeink: 'Slični materijali',
        további_termékeink: 'Drugi tekstili',
        tavasz_nyár: 'Proleće-Leto',
        ősz_tél: 'Jesen-Zima',
        műszőrmék: 'Veštačko Krzno'
      }
};



  constructor() { }



getTrans(item: string, lang: string) {
  let lan: string;
  if (lang) {
    lan = lang;
  } else {
    lan = 'hu';
  }
  if (item){
    let key: string = item.toLowerCase();
    key = key.split(' ').join('_');
    key = key.split('-').join('_');
    const trans: string = this.transaltions[lan][key];
    if (trans) {
      return trans;
    } else {
      return item;
    }
  }else {return "no translation"}
}


}
